import React from 'react';
import { Link } from 'react-router-dom';

const LegalNotices = () => {
  return (
    <div className="min-h-screen bg-gray-900 text-white">
      {/* Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gray-800 rounded-xl p-8 shadow-xl">
            
            {/* Header */}
            <div className="mb-8 pb-6 border-b border-gray-700">
              <div className="flex items-center space-x-4 mb-4">
                <Link 
                  to="/" 
                  className="text-cyan-400 hover:text-cyan-300 transition-colors flex items-center space-x-2"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"/>
                  </svg>
                  <span>Retour à l'accueil</span>
                </Link>
              </div>
              <h1 className="text-3xl lg:text-4xl font-bold text-white mb-2">Mentions Légales</h1>
              <p className="text-gray-400">Dernière mise à jour: {new Date().toLocaleDateString('fr-FR')}</p>
            </div>

            {/* Introduction */}
            <section className="mb-8">
              <div className="text-gray-300 leading-relaxed">
                <p>
                  Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la confiance en l'économie numérique, 
                  il est précisé aux utilisateurs du site "pimp my drop" l'identité des différents intervenants dans le cadre 
                  de sa réalisation et de son suivi.
                </p>
              </div>
            </section>

            {/* Éditeur du site */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">1. Éditeur du Site</h2>
              <div className="text-gray-300 leading-relaxed space-y-2">
                <p>Le présent site, pimp my drop, est édité par :</p>
                <div className="bg-gray-700 p-4 rounded-lg mt-4">
                  <p><strong>AKS - FZCO</strong></p>
                  <p>Société de type Free Zone Company (FZCO)</p>
                  <p><strong>Siège social :</strong> A-305-M, Building A3, IFZA, Dubai, United Arab Emirates</p>
                </div>
              </div>
            </section>

            {/* Hébergement */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">2. Hébergement du Site</h2>
              <div className="text-gray-300 leading-relaxed">
                <p>Le site "pimp my drop" est hébergé par :</p>
                <div className="bg-gray-700 p-4 rounded-lg mt-4 space-y-1">
                  <p><strong>OVH SAS</strong></p>
                  <p>Société par actions simplifiée au capital de 10 069 020 €</p>
                  <p><strong>Siège social :</strong> 2 rue Kellermann – 59100 Roubaix – France</p>
                  <p><strong>RCS :</strong> Lille Métropole 424 761 419</p>
                  <p><strong>N° TVA :</strong> FR 22 424 761 419</p>
                  <p><strong>Téléphone :</strong> 1007 (numéro unique et gratuit depuis un poste fixe, hors surcoût éventuel selon opérateur depuis une ligne mobile)</p>
                </div>
              </div>
            </section>

            {/* Propriété intellectuelle */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">3. Propriété Intellectuelle</h2>
              <div className="text-gray-300 leading-relaxed space-y-4">
                <p>
                  L'ensemble des éléments graphiques, de la structure et, plus généralement, du contenu du site "pimp my drop" 
                  sont protégés par le droit d'auteur et le droit des marques. Toute personne qui recueille ou télécharge du 
                  contenu ou des informations diffusées sur le site ne dispose sur ceux-ci que d'un droit d'usage privé, 
                  personnel et non transmissible.
                </p>
                <p>
                  Toute reproduction ou représentation, en tout ou partie, du site ou des éléments le composant, est interdite 
                  sans l'autorisation expresse de la société Allkeyshop Limited et constituerait une contrefaçon sanctionnée 
                  par le Code de la propriété intellectuelle.
                </p>
                <p>
                  Concernant les designs téléversés par les utilisateurs, les conditions de cession de droits sont détaillées 
                  dans nos Conditions Générales d'Utilisation et Politique de Confidentialité
                </p>
              </div>
            </section>

            {/* Données personnelles */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">4. Données Personnelles</h2>
              <div className="text-gray-300 leading-relaxed">
                <p>
                  La gestion et la protection des données personnelles sont décrites dans notre{' '}
                  Conditions Générales d'Utilisation et Politique de Confidentialité, 
                  conformément au Règlement Général sur la Protection des Données (RGPD).
                </p>
              </div>
            </section>

          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalNotices; 